export default __webpack_public_path__ + "static/metamask@2x-ec52dce4b8395f8972f3b19c42fd22d5.png";